import { NgClass, NgFor, NgIf, NgTemplateOutlet } from '@angular/common';
import { Component, Input } from '@angular/core';
import {
  DividerComponent,
  TooltipDirective
} from '@com-delta-omnichannel/aura';
import { Status } from './models/status.interfaces';

@Component({
  selector: 'idp-status',
  standalone: true,
  imports: [
    NgClass,
    NgIf,
    NgFor,
    NgTemplateOutlet,
    TooltipDirective,
    DividerComponent
  ],
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.scss']
})
export class StatusComponent {
  @Input() content: Status = {} as Status;
}
